import { Transporter } from './transporter';

export class Subscriber {
    Id: number;
    Name: string;
    Transporters: Transporter[];
}

export class SubscriberConfig  {

    Id: number;
    SubscriberId: number;
    Key: string;
    Value: string;
}

export class SubscriberMetaData {   

    Configurations: SubscriberConfig[];

    Subscriber: Subscriber;
}



// WEBPACK FOOTER //
// D:/TFS/Softec.FMS-Core-Live/Source/Frontend/Web/Softec.FMS.Client.WebView-ng4/app/shared/dataModels/app-config.ts